import React from 'react';
import '../App/App.css';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import DenseAppBar from '../Header/Header';
import Footer from '../Footer/Footer';
import { Button, Card, CardActions, CardContent, FormControl, FormHelperText, Input, InputLabel } from '@material-ui/core';
import { useNavigate } from 'react-router-dom';

function Scene() {


    const navigate = useNavigate();

    const [time, setTime] = React.useState("");
    const [speed, setSpeed] = React.useState("");
    const [blur, setBlur] = React.useState("");

    function goto() {
        navigate("/")
      }

  const handleChangeDecimals = (e, type) => {
    console.log("hey")
    const regex = /^\d*\.?\d*$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
        if (type === "speed"){
            setSpeed(e.target.value);
        } else if (type === "blur"){
            setBlur(e.target.value);
        }
    }
}

  const submit = () => {
    const regex = /^\d*\.?\d*$/;
    if (!regex.test(speed)) {
    alert("Speed is not correct or not filled in, try again.")
  } else if (!regex.test(blur)) {
    alert("Blur is not correct or not filled in, try again.")
  } else if (speed === "" || blur === "") {
    alert("Not all fields are filled in, try again.")
  } else if ((regex.test(speed)) && (regex.test(blur))){
        // Calculate blur
        setTime(blur/speed)
    }
  }

  return (
    <div>
      <DenseAppBar></DenseAppBar>
    <Container maxWidth="lg" className="App">
    <Typography variant="h4" color="black" style={{margin: 50}}>
          Fill in the specifications to calculate the exposure time
    </Typography>
    <Card sx={{ maxWidth: 900}} style={{ border: "3px solid #5BDCDF" }}>
      <CardContent>
        <Typography gutterBottom variant="h5" component="div" >
        Speed of camera or object
        </Typography>
        <Typography variant="body2" color="secondary">
        The speed of the camera or object being photographed, typically measured in millimeters per second (mm/s), which affects the motion blur in the resulting image.
        </Typography>
        <FormControl error={false}>
            <InputLabel htmlFor="my-input">mm/s</InputLabel>
            <Input id="my-input" aria-describedby="my-helper-text" onChange={(e) => handleChangeDecimals(e, "speed")} value={speed}></Input>
            
            <FormHelperText id="my-helper-text">Only positive numbers are accepted.</FormHelperText>
        </FormControl>
        <Typography gutterBottom variant="h5" component="div" style={{marginTop: 100}}>
          Maximum blur
        </Typography>
        <Typography variant="body2" color="secondary">
        The maximum blur of the camera or object being photographed, typically measured in millimeters (mm).
        </Typography>
        <FormControl error={false}>
            <InputLabel htmlFor="my-input3">mm</InputLabel>
            <Input id="my-input3" aria-describedby="my-helper-text3" onChange={(e) => handleChangeDecimals(e, "blur")} value={blur}></Input>
            
            <FormHelperText id="my-helper-text3">Only positive numbers are accepted.</FormHelperText>
        </FormControl>
        

        </CardContent>
      <div style={{display:"flex", justifyContent:"center", width: "100%"}}>
      <CardActions>
        <Button variant="contained" color="secondary" size="small" onClick={submit}>Calculate the exposure time</Button>
      </CardActions>
      </div>
    </Card>

    {time !== "" && <>
    <Card>
    <Typography gutterBottom variant="h5" component="div">
          Exact results
        </Typography>
        {/* <Typography variant="body2" color="text.secondary">
          Field of View: {FOV}
        </Typography> */}
        <Typography variant="body2" color="text.secondary">
          Exposure/shutter: {time} s
        </Typography>
    </Card></>}



    <Button variant="contained" color="secondary" size="small" onClick={goto}>Start over (to home)</Button>
    </Container>
    <Footer></Footer>
    </div>
  );
}

export default Scene;